import React, { useEffect, useRef, useState } from 'react'

import DataTableList from '../../components/DataTable/DataTableList'
import NoResults from '../../components/Noresults';
import CustomDatePicker from '../../components/CustomDatePicker';
import { formattedDate } from '../../utils/formattedDate';

import search from '../../assets/images/search.svg';
import vc from '../../assets/images/vc.png'
import avatar from '../../assets/images/Avatar.png'

const NotCompletedVCs = (props) => {
    const {
        setShowAddNewVcPopup, setSelectVC, isLoading, isLoadingData, vcList, totalPage, setEditVC, setIsLoadingData, currentPage, setSearchQuery, searchQuery, setFilterVc, filterVc, setShowVcSuspendPopup, setShowVcMultipleSuspendPopup, selectedRows, setSelectedRows, isAllSelected, setIsAllSelected, toggleSelect, setErrorMessage, setCurrentPage, setReason, LazyImage, setAddVcErrorMessage
    } = props

    const userDateRef = useRef();

    const [userDateSelect, setUserDateSelect] = useState(false)
    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        if (vcList?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 1000);
            });
        }
    }, [vcList]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(vcList?.map((row) => row?.userId));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleDelete = async () => {
        if (selectedRows?.length === 1) {
            const selected = vcList?.find((row) => row?.userId === selectedRows[0]);
            if (selected) {
                setSelectVC(selected);
            }
            setShowVcSuspendPopup(true);
        }

        if (selectedRows?.length > 1) {
            setShowVcMultipleSuspendPopup(true);
        }
        setErrorMessage('')
    };

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = vcList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    if (key === 'industry') {
                        const categories = row[key];

                        if (categories?.length > 1) {
                            let tempCatLength = 0;

                            for (let i = 0; i < 1; i++) {
                                tempCatLength = tempCatLength + categories[i]?.length;
                            }

                            maxContentLength = Math?.max(tempCatLength, title?.length);

                        } else {
                            if (categories?.length == 0) {
                                maxContentLength = Math?.max(dataValue?.length + 5);
                            } else {
                                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
                            }
                        }

                    } else {
                        maxContentLength = Math?.max(dataValue?.length, title?.length);
                    }

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {

                    if (key === 'industry') {
                        vcList.forEach((row) => {
                            const categoryWidth = tempWidths[key] * 10 + 40;
                            acc[key] = `${categoryWidth}px`;
                        });
                    } else {
                        acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    }
                    return acc;
                }, {});

                setColumnWidths(widthMap);
            }
            resolve();
        });

    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };

    const handleEditClick = async (row) => {
        try {
            setEditVC(true);
            setSelectVC(row);
        } catch (error) {
            console.error('Failed to fetch user detail on edit:', error);
        }
    };

    const columns = [
        {
            name: 'Investor name',
            selector: (row) => row?.name,
            cell: (row) => {
                return (
                    <div className="vc-content vcTable" onClick={() => { handleEditClick(row); setReason('') }}>
                        <LazyImage
                            src={row?.profileImg || avatar}
                            alt="Not completed vc"
                        />
                        <div className="vc-brief">
                            <span className="vc-name">
                                {row?.name || 'NO NAME'}
                            </span>
                        </div>
                    </div>
                )
            },
            sortable: true,
            minWidth: columnWidths['name'] && (parseInt(columnWidths['name']) > 300) ? '300px' : `${parseInt(columnWidths['name']) + 60}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Email address',
            selector: (row) => row?.email,
            cell: (row) => {
                return <p className="user-mail">{row?.email}</p>
            },
            sortable: true,
            width: columnWidths['email'] && (parseInt(columnWidths['email']) + 20 > 300) ? '300px' : `${parseInt(columnWidths['email']) + 5}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Date registered',
            selector: (row) => row?.registeredAt,
            cell: (row) => {
                return <p>{formattedDate(row?.registeredAt)}</p>
            },
            sortable: true,
            width: columnWidths['registeredAt'] && `${parseInt(columnWidths['registeredAt']) - 105}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                        <div className='table-actions'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { handleEditClick(row); setReason('') }}>
                                <path d="M2.15703 13.583C2.19149 13.2729 2.20872 13.1179 2.25564 12.9729C2.29726 12.8444 2.35607 12.722 2.43048 12.6092C2.51434 12.482 2.62466 12.3717 2.8453 12.151L12.75 2.24632C13.5784 1.41789 14.9216 1.41789 15.75 2.24632C16.5784 3.07475 16.5784 4.41789 15.75 5.24632L5.84529 15.151C5.62466 15.3717 5.51434 15.482 5.38717 15.5658C5.27434 15.6402 5.15197 15.6991 5.02338 15.7407C4.87845 15.7876 4.72339 15.8048 4.41328 15.8393L1.875 16.1213L2.15703 13.583Z" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setShowVcSuspendPopup(true); setSelectVC(row); setErrorMessage(''); }}>
                                <path d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </>
                )
            },
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            minWidth: "55px",
            paddingRight: '16px',
            width: '70px',
            style: { textAlign: 'right', minWidth: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
    ]

    return (
        <div className='active-vcs'>
            <div className='active-vc-top'>
                <div className='pagesSearch twoItemWrap'>
                    <div className="pageSearchInput">
                        <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search not completed VCs...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                        <img src={search} alt="Search" />
                    </div>

                    <CustomDatePicker
                        onApply={(dateRange) => {
                            setFilterVc(prev => ({
                                ...prev,
                                registedDate: dateRange
                            }));
                            setUserDateSelect(false);
                        }}
                        selectedDate={filterVc?.registedDate}
                        onCancel={() => setUserDateSelect(false)}
                        isSelectDate={userDateSelect}
                        ref={userDateRef}
                        setSelectDate={setUserDateSelect}
                        label={"Date registered"}
                    />

                </div>
                <div className='new-vc'>
                    {selectedRows?.length > 0 &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { handleDelete(); setReason(''); }}>
                            <path d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                    <button className='new-vc-button' onClick={() => { setShowAddNewVcPopup(true); setAddVcErrorMessage({ name: '', email: '' }) }}>New VC</button>
                </div>
            </div>
            <div className='table-pagination-wrapper vc-list'>
                <div className={`pagesTable dataTable-list ${(isLoadingData) ? 'loading-list' : ''}`}>
                    <DataTableList
                        data={vcList}
                        columns={columns}
                        customStyles={customStyles}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        currentPage={currentPage}
                        selectableRowsComponent="input"
                        selectableRows={true}
                        selectAllRows={isAllSelected}
                        onSelectAllChange={handleMasterCheckboxChange}
                        clearSelectedRows={toggleSelect}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows?.map((row) => row?.userId);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds?.length === vcList?.length);
                        }}
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={<NoResults title='No incomplete registrations yet' description="Looks like there aren’t any VCs with incomplete registration right now. Keep an eye out - new money is starting the journey every day!" image={vc} />}
                    />
                </div>
            </div>
        </div>
    )
}

export default NotCompletedVCs
